import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { UtilPipesModule } from '@core/shared/util';

type ToastData = {
  articleName: string;
  number: string;
  costCenterName: string;
};

@Component({
  templateUrl: './add-to-cart-toast.component.html',
  styleUrl: './add-to-cart-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UtilPipesModule],
})
export class AddToCartToastComponent {
  public readonly data: ToastData = inject(MAT_SNACK_BAR_DATA);
}
